import appEnums from 'enums/app';
import { appEventTypes } from 'events/app';
import { userEventTypes } from 'events/user';
import { uiEventTypes } from 'events/ui';
import initialState from 'reducers/initialStates/app';

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case uiEventTypes.WIDGET_INITIATE:
      return handleWidgetInitiate(state, action);

    case appEventTypes.APP_INITIALIZED:
      return handleAppInitialized(state);

    case userEventTypes.USER_CREATE:
      return handleUserCreate(state);

    case appEventTypes.AUTHENTICATION_SUCCESS:
      return handleAuthenticationSuccess(state);

    case appEventTypes.AUTHENTICATION_ERROR:
      return handleAuthenticationError(state, action);

    case appEventTypes.CLEAR_CURRENT_RULE:
      return handleClearCurrentRule(state);

    case appEventTypes.CHAT_CLIENT_CONNECTED:
      return handleClientConnected(state);

    case appEventTypes.CHAT_CLIENT_DISCONNECTED:
      return handleClientDisconnected(state);

    case appEventTypes.CHAT_CLIENT_RECONNECT:
      return handleClientReconnecting(state);

    case appEventTypes.FETCH_ESTIMATED_WAIT_TIME_SUCCESS:
      return handleFetchEstimatedWaitTimeSuccess(state, action);

    case appEventTypes.SERVER_ERROR:
      return handleServerError(state, action);

    case appEventTypes.PROACTIVE_TRIGGERED:
      return handleProactiveTriggered(state);

    case appEventTypes.SET_CURRENT_RULE:
      return handleSetCurrentRule(state, action);

    default:
      return state;
  }
}

function handleWidgetInitiate(state, action) {
  const { orgDomain, loginDomain, appId, providerId, orgId, cdn } = action.payload;
  return { ...state, orgDomain, loginDomain, appId, providerId, orgId, cdn };
}

function handleAppInitialized(state) {
  return { ...state, initialized: true };
}

function handleUserCreate(state) {
  return { ...state, clientReady: false, _authError: null, _serverError: null };
}

function handleAuthenticationSuccess(state) {
  return { ...state, clientReady: true, _authError: null, _serverError: null };
}

function handleAuthenticationError(state, action) {
  return { ...state, clientReady: false, _authError: action.payload };
}

function handleClearCurrentRule(state) {
  return { ...state, currentRule: null };
}

function handleClientConnected(state) {
  return { ...state, chatClientConnectionStatus: appEnums.chatClientConnectionStatuses.CONNECTED };
}

function handleClientDisconnected(state) {
  return { ...state, chatClientConnectionStatus: appEnums.chatClientConnectionStatuses.DISCONNECTED };
}

function handleClientReconnecting(state) {
  return { ...state, chatClientConnectionStatus: appEnums.chatClientConnectionStatuses.RECONNECTING };
}

function handleFetchEstimatedWaitTimeSuccess(state, action) {
  return { ...state, estimatedWait: action.payload.estimatedWait };
}

function handleServerError(state, action) {
  return { ...state, ready: false, clientReady: false, _serverError: action.payload.reason };
}

function handleProactiveTriggered(state) {
  return { ...state, proactiveTriggered: true };
}

function handleSetCurrentRule(state, action) {
  return { ...state, currentRule: action.currentRule };
}
